<template>
  <header
    class="top-0 z-50 w-full border-b border-[#111814]/10 bg-white/90 backdrop-blur px-6 py-3 shadow-sm"
  >
    <div class="flex items-center justify-between gap-6">
      <div class="flex items-center gap-4">
        <router-link to="/explorer" class="flex items-center gap-2">
          <img
            :src="require('/assets/images/mydid25-color-isotype-only.png')"
            alt="myDid"
            class="h-8 w-auto"
          />
          <span class="text-lg font-semibold text-[#111814]">myDid Check</span>
        </router-link>
      </div>

      <!-- Desktop nav -->
      <nav class="hidden md:flex items-center gap-3 text-sm font-semibold">
        <router-link
          class="rounded-full border border-[#111814]/10 px-4 py-2 text-[#111814] hover:border-[#3b82f6]/30 hover:text-[#3b82f6] hover:bg-white/60"
          to="/explorer"
        >
          Explorer
        </router-link>
        <router-link
          class="rounded-full border border-[#111814]/10 px-4 py-2 text-[#111814] hover:border-[#3b82f6]/30 hover:text-[#3b82f6] hover:bg-white/60"
          to="/about"
        >
          About
        </router-link>
      </nav>

      <!-- Mobile hamburger -->
      <button
        class="md:hidden flex items-center justify-center w-9 h-9 rounded-lg border border-[#111814]/10"
        @click="mobileMenuOpen = !mobileMenuOpen"
        aria-label="Toggle menu"
      >
        <svg
          v-if="!mobileMenuOpen"
          class="w-5 h-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4 6h16M4 12h16M4 18h16"
          />
        </svg>
        <svg
          v-else
          class="w-5 h-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
    </div>

    <!-- Mobile menu -->
    <nav
      v-if="mobileMenuOpen"
      class="md:hidden mt-3 pb-2 flex flex-col gap-2 text-sm font-semibold"
    >
      <router-link
        class="rounded-lg px-4 py-2.5 text-[#111814] hover:bg-[#f5f8f7] transition-colors"
        to="/explorer"
        @click="mobileMenuOpen = false"
      >
        Explorer
      </router-link>
      <router-link
        class="rounded-lg px-4 py-2.5 text-[#111814] hover:bg-[#f5f8f7] transition-colors"
        to="/about"
        @click="mobileMenuOpen = false"
      >
        About
      </router-link>
    </nav>
  </header>
</template>

<script>
export default {
  data() {
    return {
      mobileMenuOpen: false,
    };
  },
};
</script>
